import * as S from './styles';
import { useMemo } from 'react';
import { Product, Slider } from '@/components';
import { CardMode, ProductProps, TaxSubstitutionProps } from '@/types';

interface Products {
  id: string;
  dots?: boolean;
  cardMode: CardMode;
  products: ProductProps[];
  slideToShow?: number | 'auto';
  onProductNavigate?: (productId: number) => void;
  addProductToCart: ({
    sku,
    uid,
    option_uid,
    quantity,
    category_id,
  }: {
    sku: number;
    uid: string;
    quantity: number;
    option_uid: string;
    category_id: number;
  }) => void;
  substTrib: TaxSubstitutionProps[];
  updateProductAmount: ({ sku, uid, quantity }: { sku: number; uid: string; quantity: number }) => void;
  removeProductFromCart: ({ uid }: { uid: string }) => void;
  setPageLastPurchase?: (page: number) => void;
  showComboPricing?: boolean;
}

const RenderSliderProducts = ({
  id,
  dots,
  cardMode,
  products,
  slideToShow,
  substTrib,
  setPageLastPurchase,
  onProductNavigate,
  showComboPricing = false,
}: Products) => {
  const promocoes = useMemo(
    () =>
      products?.map((item: ProductProps, ind: number) => (
        <S.ProductContainer key={`${id}-${ind}`}>
          <Product
            direction={cardMode}
            product={{ ...item }}
            substTrib={substTrib}
            onProductNavigate={onProductNavigate ? () => onProductNavigate(item.COD_PRODUTO) : undefined}
            showComboPricing={showComboPricing}
          />
        </S.ProductContainer>
      )) || [],
    [products, cardMode, id, onProductNavigate, showComboPricing]
  );

  return (
    <Slider
      id={id}
      canSwipe
      dots={dots}
      slides={promocoes}
      slidesToShow={slideToShow ?? 'auto'}
      className="promotional"
      setActiveIndex={setPageLastPurchase ? setPageLastPurchase : () => { }}
    />
  );
};

export default RenderSliderProducts;
